import React from "react";
import get from "lodash/get";
import { ProfileImage } from "../profile-image";
import format from "date-fns/format";
import EntityShare from "../entity-share/entity-share";

import "./entity-details.m.css";

export const ProfileTopPeople = ({ item, sketchesHost }) => {
  const profileImg = get(item, ["profile-image"], []);
  let dob = item?.["birth-year"];
  const profileUrl = sketchesHost + "/people/" + item?.slug;
  if (item?.["birth-month"] & item?.["birth-day"]) {
    const fulldate = item?.["birth-year"] + "-" + item?.["birth-month"] + "-" + item?.["birth-day"];
    dob = format(new Date(fulldate), "MMM dd, yyyy");
  }
  return (
    <div styleName="entity-details-header people">
      <div styleName="profile-content">
        <div styleName="profile-content-left">
          <h1 styleName="headline">{item?.name}</h1>
          <p styleName="sub-headline">{item?.["designation-occupation"]}</p>
        </div>
        <div styleName="profile-content-rt">
          <EntityShare title={item?.name} url={profileUrl} />
        </div>
      </div>
      <div styleName="profile-image">
        <ProfileImage imageUrl={profileImg} isDetails={true} />
      </div>
      <div styleName="entity-meta-data">
        {item?.["also-known-as"] && (
          <div styleName="row-data">
            <span>Also Known As:</span>
            {item?.["also-known-as"]}
          </div>
        )}
        {item?.nationality && (
          <div styleName="row-data">
            <span>Nationality:</span>
            {item?.nationality}
          </div>
        )}
        {item?.["birth-year"] && (
          <div styleName="row-data">
            <span>Born:</span>
            {dob}
          </div>
        )}
        {item?.["known-for"] && (
          <div styleName="row-data">
            <span>Known For:</span>
            {item?.["known-for"]}
          </div>
        )}
        {item?.["notable-achievements"] && (
          <div styleName="row-data">
            <span>Notable Achievements:</span>
            {item?.["notable-achievements"]}
          </div>
        )}
        {item?.associations && (
          <div styleName="row-data">
            <span>Associations:</span>
            {item?.associations}
          </div>
        )}
      </div>
    </div>
  );
};
